import React from 'react';
import {
  Switch,
  Route,
  useRouteMatch,
} from 'react-router-dom';

import {
  PagePaymentRecords,
  PagePaymentRecord,
} from '../pages/paymentRecords';

const RoutePaymentRecords = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <PagePaymentRecords />
      </Route>
      <Route path={`${path}/:_id`}>
        <PagePaymentRecord />
      </Route>
    </Switch>
  );
};

export default RoutePaymentRecords;
